import { WorkspaceAction } from '@sales-app/context/workspace/workspace.actions'
import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { HomeFilters } from '@sales-app/context/workspace/workspace.type'
import { Status } from '@sales-app/graphql/queries/potentialBooking/status.queries'
import { getPotentialBookingStatusClassNames } from '@sales-app/views/Workspace/PersonSummary/PersonSummary.data'
import React, { FC, useState } from 'react'

import { Dropdown, Tag } from '@/components'

type Props = {
  currentFilters: HomeFilters
  isSupervisor: boolean
  potentialBookingStatuses: Status[]
}

interface Option {
  label: string
  value: number
}

export const StatusSelection: FC<Props> = ({ currentFilters, isSupervisor, potentialBookingStatuses }) => {
  const [, WorkspaceDispatch] = useWorkspaceContext()
  const [dropdownExpanded, setDropdownExpanded] = useState(false)

  const availablePotentialBookingStatuses =
    potentialBookingStatuses.filter(
      (potentialBookingStatus) =>
        potentialBookingStatus.lifecycleState === 'Pending' &&
        (isSupervisor || potentialBookingStatus.manualChangeAllowed),
    ) || []

  const options = availablePotentialBookingStatuses.map((status) => {
    return { label: status.description, value: status.id }
  })

  const changeStatus = (status: Option) => {
    WorkspaceDispatch(
      WorkspaceAction.updateFilters({
        status: {
          id: status.value,
          description: status.label,
        },
      }),
    )
    setDropdownExpanded(false)
  }

  const currentStatus = currentFilters.status?.description || ''

  return (
    <Dropdown
      className="w-auto"
      disabled={options.length === 0}
      expanded={dropdownExpanded}
      onHideDropdown={() => {}}
      renderToggle={() => {
        return (
          <div className="flex w-full items-center justify-center">
            <Tag className={getPotentialBookingStatusClassNames(currentStatus)} variant="none">{currentStatus}</Tag>
          </div>
        )
      }}
      setExpanded={setDropdownExpanded}
    >
      <div className="flex w-48 flex-col px-4 py-4">
        {options.map((o, i) => {
          return (
            <button
              className={`cursor-pointer rounded-xl px-3 py-2 leading-140 ${getPotentialBookingStatusClassNames(
                o.label,
              )} ${i > 0 ? 'mt-3' : ''}`}
              key={o.value}
              onClick={() => changeStatus(o)}
            >
              {o.label}
            </button>
          )
        })}
      </div>
    </Dropdown>
  )
}
